import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { KpiMetricsComponent } from '../components/kpi-metrics/kpi-metrics.component';
import { KpiCompaniesComponent } from '../components/kpi-companies/kpi-companies.component';
import {
  ExternalCompanyMetricsComponent,
} from '../components/metrics-company-manual-fill/external-company-metrics.component';
import { AuthGuard } from '../../../util/guards/login.guard';
import {
  KpiPortfolioAnalysisComponent,
} from "../components/kpi-metrics-main/portfolio-analysis/kpi-portfolio-analysis.component";
import { KpiMetricsMainComponent } from "../components/kpi-metrics-main/kpi-metrics-main.component";
import { KpiBulkRequestComponent } from "../kpi-bulk-request/kpi-bulk-request.component";
import { KpiCompaniesMainComponent } from "../components/kpi-companies-main/kpi-companies-main.component";
import { KpiCrossCompanyComponent } from "../components/kpi-metrics-main/cross-company/kpi-cross-company.component";

export const KPI_URLS = {
  base: 'kpi',
  _crossPortfolio: 'cross-portfolio',
  _companiesMain: 'companies',
  _companyMetrics: 'selected',
  _companies: 'all',
  _bulkRequest: 'bulk-request',
  _crossMetric: 'cross-metric',
  _crossCompany: 'cross-company',
  _external: 'external',
  _shared_link: 'shared-link',
};

export const getKpiCompanyMetricsUrl = (companyUUID = ''): string =>
  `/${KPI_URLS.base}/${KPI_URLS._companiesMain}/${KPI_URLS._companyMetrics}/${companyUUID}`;
export const getKpiAllCompaniesUrl = (): string =>
  `/${KPI_URLS.base}/${KPI_URLS._companiesMain}/${KPI_URLS._companies}`;
export const getKpiCrossPortfolioUrl = (withStartingSlash = false): string =>
  `${withStartingSlash ? '/' : '' }${KPI_URLS.base}/${KPI_URLS._crossPortfolio}`;
export const getKpiBaseUrlForBox = (): string => `${KPI_URLS.base}/`;
export const getKpiBaseWithSharedPartUrlForBox = (): string => `${KPI_URLS.base}/${KPI_URLS._shared_link}/`;

const routes: Routes = [
  { path: '', redirectTo: KPI_URLS._crossPortfolio, pathMatch: 'full' },
  {
    path: '',
    children: [
      {
        canActivate: [AuthGuard],
        path: KPI_URLS._crossPortfolio,
        component: KpiMetricsMainComponent,
        children: [
          { path: '', redirectTo: KPI_URLS._crossMetric, pathMatch: 'full' },
          { path: KPI_URLS._crossMetric, component: KpiPortfolioAnalysisComponent },
          { path: KPI_URLS._crossCompany, component: KpiCrossCompanyComponent },
        ],
      },
      {
        canActivate: [AuthGuard],
        path: KPI_URLS._companiesMain,
        component: KpiCompaniesMainComponent,
        children: [
          {
            canActivate: [AuthGuard],
            path: KPI_URLS._companies, component: KpiCompaniesComponent,
          },
          { path: KPI_URLS._companyMetrics + '/:uuid',
            component: KpiMetricsComponent },
          {
            path: KPI_URLS._companyMetrics,
            redirectTo: KPI_URLS._companyMetrics + '/',
            pathMatch: 'full',
          },
        ],
      },
      {
        canActivate: [AuthGuard],
        path: KPI_URLS._bulkRequest, component: KpiBulkRequestComponent,
      },
      {
        path: KPI_URLS._external, component: ExternalCompanyMetricsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class KpiModuleRoutingModule {
}
